import { Type } from '@sinclair/typebox';
import { SortableSupplierInvoiceKeysSchema, SortableSupplierInvoiceSchema, } from '../../domain/supplier-invoices/sortable-supplier-invoice-schema.js';
import { NullishType, YearMonthDayStringType } from '../../standard-schema.js';
import { SupplierInvoiceStatusType, VatType } from '../../supplier-invoice-schema.js';
export const AdminListSupplierInvoiceSchema = Type.Object({
    id: Type.String(),
    project: Type.Object({
        id: Type.String(),
        name: Type.String(),
        fortnoxId: Type.String(),
    }),
    accountType: Type.String(),
    invoiceNumber: Type.String(),
    status: Type.String(),
    supplier: Type.String(),
    totalAmount: Type.Number(),
    pennyAdjust: Type.Number(),
    vat: Type.Number(),
    invoiceDate: Type.String(),
    dueDate: Type.String(),
    approver: Type.String(),
    supplierInvoiceNumber: Type.String(),
    booked: Type.Boolean(),
    finalPayDate: NullishType(Type.String()),
    paymentFileId: NullishType(Type.Number()),
});
export const AdminListSupplierInvoiceResponseSchema = Type.Array(AdminListSupplierInvoiceSchema);
export const AdminListSupplierInvoiceQuerySchema = Type.Object({
    supplierId: Type.Optional(Type.String()),
});
export const AdminCreateSupplierInvoiceRowSchema = Type.Object({
    id: Type.Union([Type.String(), Type.Null()]),
    rowIndex: Type.Number(),
    accountNumber: Type.Number(),
    accountName: Type.Union([Type.String(), Type.Null()]),
    projectId: Type.Union([Type.String(), Type.Null()]),
    // 20@tag:vera-2.5:not-here - this should not change
    debit: Type.Number(),
    credit: Type.Number(),
});
export const AdminCreateSupplierInvoiceParamsSchema = Type.Object({
    id: Type.String(),
});
const AdminSupplier = Type.Object({
    name: Type.String(),
    supplierNumber: Type.String(),
    organisationNumber: Type.String(),
    streetName: Type.String(),
    buildingNumber: Type.String(),
    zipCode: Type.String(),
    city: Type.String(),
    bankGiro: Type.Union([Type.String(), Type.Null()]),
    postGiro: Type.Union([Type.String(), Type.Null()]),
    bic: Type.String(),
    iban: Type.String(),
    vatNumber: Type.String(),
});
const AdminSupplierInvoie = Type.Object({
    fortnoxId: Type.Union([Type.String(), Type.Null()]),
    projectId: Type.String(),
    invoiceDate: Type.String(),
    dueDate: Type.String(),
    termsOfPayment: Type.String(),
    ocr: Type.String(),
    bankGiro: Type.Union([Type.String(), Type.Null()]),
    postGiro: Type.Union([Type.String(), Type.Null()]),
    totalAmount: Type.Number(),
    pennyAdjust: Type.Number(),
    vat: Type.Number(),
    invoiceNumber: Type.String(),
    notes: Type.String(),
    currency: Type.String(),
    accountNumber: Type.Union([Type.Number(), Type.Null()]),
    accountName: Type.Union([Type.String(), Type.Null()]),
    vatType: Type.String(),
    rows: Type.Array(AdminCreateSupplierInvoiceRowSchema),
    status: Type.String(),
});
const AdminSupplierInvoiceDocument = Type.Object({
    blob: Type.Union([Type.String(), Type.Null()]),
    name: Type.Union([Type.String(), Type.Null()]),
    inboxDocumentId: Type.Union([Type.String(), Type.Null()]),
});
const AdminSupplierWithoutIBANandBIC = Type.Omit(AdminSupplier, ['bic', 'iban']);
const AdminSupplierInvoieWithoutRows = Type.Omit(AdminSupplierInvoie, ['rows']);
export const AdminCreateSupplierInvoiceRequestSchema = Type.Object({
    supplier: AdminSupplierWithoutIBANandBIC,
    invoice: AdminSupplierInvoieWithoutRows,
    document: AdminSupplierInvoiceDocument,
});
export const AdminCreateSupplierInvoiceResponseSchema = Type.Object({
    supplier: AdminSupplier,
    invoice: AdminSupplierInvoie,
    document: AdminSupplierInvoiceDocument,
});
export const AdminUpdateSupplierInvoiceRequestSchema = Type.Object({
    supplier: AdminSupplierWithoutIBANandBIC,
    invoice: AdminSupplierInvoie,
});
export const GetAdminSupplierInvoiceParamsSchema = Type.Object({
    id: Type.String(),
});
export const GetAdminSupplierInvoiceSchema = Type.Object({
    id: Type.String(),
    project: Type.String(),
    projectId: Type.String(),
    accountType: Type.String(),
    serialNumber: Type.String(),
    invoiceNumber: Type.String(),
    ocr: Type.String(),
    organisationNumber: Type.String(),
    bankGiro: Type.String(),
    plusGiro: Type.String(),
    bic: Type.String(),
    iban: Type.String(),
    vatNumber: Type.String(),
    address: Type.String(),
    zipCode: Type.String(),
    city: Type.String(),
    account: Type.String(),
    currency: Type.String(),
    vatType: Type.String(),
    booked: Type.Boolean(),
    status: Type.String(),
    supplierNumber: Type.String(),
    supplier: Type.String(),
    totalAmount: Type.Number(),
    pennyAdjust: Type.Number(),
    vat: Type.Number(),
    invoiceDate: Type.String(),
    dueDate: Type.String(),
    approver: Type.String(),
    notes: Type.String(),
    rows: Type.Array(AdminCreateSupplierInvoiceRowSchema),
    docId: Type.Union([Type.String(), Type.Null()]),
    blob: Type.Union([Type.String(), Type.Null()]),
    name: Type.Union([Type.String(), Type.Null()]),
});
export const AdminListSupplierSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    orgNumber: Type.String(),
    email: Type.String(),
    phone: Type.String(),
    status: Type.String(),
    address: Type.String(),
    city: Type.String(),
    country: Type.String(),
});
export const AdminListSupplierResponseSchema = Type.Array(AdminListSupplierSchema);
export const AdminCreateSupplierSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    organizationNumber: Type.String(),
    vatNumber: Type.String(),
});
export const AdminCreateSupplierResponseSchema = AdminCreateSupplierSchema;
export const AdminSupplierSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    supplierNumber: Type.String(),
    organisationNumber: Type.String(),
    streetName: Type.String(),
    buildingNumber: Type.String(),
    zipCode: Type.String(),
    city: Type.String(),
    bankGiro: Type.Union([Type.String(), Type.Null()]),
    postGiro: Type.Union([Type.String(), Type.Null()]),
    paymentType: Type.Optional(Type.Union([Type.Literal('BG'), Type.Literal('PG')])),
    bic: Type.String(),
    iban: Type.String(),
    vatNumber: Type.String(),
});
export const AdminGetSuppliersResponseSchema = Type.Array(AdminSupplierSchema);
export const AdminGetNextSupplierInvoiceNumberResponseSchema = Type.Object({
    supplierInvoiceNumber: Type.String(),
});
const SortableInvoiceStatus = Type.Union([
    Type.Enum(SupplierInvoiceStatusType),
    Type.Literal('verified-debt'),
]);
export const FilterInvoicesQuerySchema = Type.Object({
    page: Type.Optional(Type.Number({ minimum: 1 })),
    limit: Type.Optional(Type.Number({ minimum: 1, default: 100 })),
    sortKey: Type.Optional(SortableSupplierInvoiceKeysSchema),
    sortOrder: Type.Optional(Type.Union([Type.Literal('asc'), Type.Literal('desc')], {
        default: 'asc',
    })),
    status: Type.Optional(SortableInvoiceStatus),
    organisationNumber: Type.Optional(Type.String()),
    supplier: Type.Optional(Type.String()),
    project: Type.Optional(Type.String()),
    query: Type.Optional(Type.String()),
});
// Canonical ordered tuple — single source of truth for the CSV export field-key
// set and column order. Matches the declaration order of
// `SupplierInvoiceCsvRow` in the server's csv converter.
export const SUPPLIER_INVOICE_CSV_FIELDS = [
    'serialNumber',
    'invoiceNumber',
    'ocr',
    'supplierName',
    'projectName',
    'projectNumber',
    'accounts',
    'status',
    'invoiceDate',
    'dueDate',
    'finalPayDate',
    'totalAmount',
    'vat',
    'booked',
    'approver',
    'paymentFileId',
];
export const SupplierInvoiceCsvFieldSchema = Type.Union(SUPPLIER_INVOICE_CSV_FIELDS.map((f) => Type.Literal(f)));
export const ExportSupplierInvoicesQuerySchema = Type.Object({
    status: Type.Optional(Type.Array(SortableInvoiceStatus)),
    vatType: Type.Optional(Type.Array(Type.Enum(VatType))),
    invoiceDateFrom: Type.Optional(YearMonthDayStringType), // YYYY-MM-DD, inclusive
    invoiceDateTo: Type.Optional(YearMonthDayStringType), // YYYY-MM-DD, inclusive
    fields: Type.Optional(Type.Array(SupplierInvoiceCsvFieldSchema)),
});
export const GetFilteredAdminInvoicesResponseSchema = Type.Object({
    total: Type.Number(),
    invoices: Type.Array(SortableSupplierInvoiceSchema),
});
